import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=becb9da4&scoped=true&style=margin-bottom%3A%200px%3B%20height%3A%2040px%3B"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=becb9da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becb9da4",
  null
  
)

export default component.exports